module.exports = __webpack_public_path__ + "static/img/icomoon.1188e6ad.svg";